"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const config_1 = require("@completeanatomy/config");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const AccessingPageLayout_1 = __importDefault(require("../../templates/AccessingPageLayout/AccessingPageLayout"));
function UnsupportedWebScreen() {
    const { t } = (0, i18n_1.useTranslation)();
    const bridge = (0, bridge_1.useBridge)();
    const config = (0, config_1.useConfigService)();
    /**
     * Opens external support hub site
     */
    const onNeedAssistanceClick = () => {
        const supportHubLink = 'https://service.elsevier.com/app/answers/detail/a_id/31777/c/17795/supporthub/complete-anatomy/';
        bridge === null || bridge === void 0 ? void 0 : bridge.openURL({ link: supportHubLink });
    };
    const openInAppClick = () => {
        window.location.href = (config === null || config === void 0 ? void 0 : config.get('OPEN_IN_CA_LINK')) || '';
    };
    return ((0, jsx_runtime_1.jsx)(AccessingPageLayout_1.default, { iconName: ui_1.Icons.Unsupported_Web_Screen, title: t(i18n_1.Strings.popups.contentDisplayError.title), subtitle: (0, jsx_runtime_1.jsx)(i18n_1.Trans, { i18nKey: "popups.contentDisplayError.description", components: { br: (0, jsx_runtime_1.jsx)("br", {}) } }), buttonText: t(i18n_1.Strings.popups.contentDisplayError.button), buttonClick: openInAppClick, onNeedAssistanceClick: onNeedAssistanceClick }));
}
exports.default = UnsupportedWebScreen;
